import React from "react";
import { Outlet } from "react-router-dom";

import "./MainLayout.scss";
import { authService } from "api/services/auth.service";

import Sidebar from "./Sidebar";
import TopBar from "./TopBar";

interface MainLayoutProps {
  children?: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const handleLogout = () => {
    authService.logout();
    window.location.href = "/login";
  };

  return (
    <div className="main-layout">
      <Sidebar />
      <div className="main-layout__content">
        <TopBar onLogout={handleLogout} />
        <main className="main-layout__main">{children ?? <Outlet />}</main>
      </div>
    </div>
  );
};

export default MainLayout;
